import type { RepairRecord } from '@avisoma/shared';
import { presentRepairFields } from '../../components/reconstructedDocument/extractionTables/repairPresentation';

/**
 * The page's Repair Report record (DR-4817): its scalars as a label grid, then the work
 * performed. Same card shell as the page's Borescope Report card. Renders nothing when the record
 * carries neither.
 */
export function RepairRecordCard({ record }: { record: RepairRecord }) {
  const entries = presentRepairFields(record);
  const workPerformed = typeof record.workPerformed === 'string' ? record.workPerformed.trim() : '';
  if (entries.length === 0 && workPerformed === '') return null;
  return (
    <div className="bg-white dark:bg-zinc-800 shadow dark:shadow-zinc-950/30 rounded-lg overflow-hidden border border-gray-200 dark:border-zinc-700">
      <div className="px-4 py-3 border-b border-gray-200 dark:border-zinc-700">
        <h2 className="text-sm font-medium text-gray-900 dark:text-zinc-100">Repair Report</h2>
      </div>
      {entries.length > 0 && (
        <div className="px-4 py-4">
          <dl className="grid grid-cols-3 gap-4">
            {entries.map(([label, value]) => (
              <div key={label}>
                <dt className="text-sm font-medium text-gray-500 dark:text-zinc-400">{label}</dt>
                <dd className="mt-1 text-sm text-gray-900 dark:text-zinc-100">{value}</dd>
              </div>
            ))}
          </dl>
        </div>
      )}
      {workPerformed !== '' && (
        <dl className="px-4 py-4 border-t border-gray-200 dark:border-zinc-700">
          <dt className="text-sm font-medium text-gray-500 dark:text-zinc-400">Work Performed</dt>
          <dd className="mt-1 text-sm text-gray-900 dark:text-zinc-100">{workPerformed}</dd>
        </dl>
      )}
    </div>
  );
}
